export default __webpack_public_path__ + "static/media/tapcart.75b675f6.svg";